module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/venue-img-four-e8167edb985d0a8e034babe03edcceab.jpg";